import Vue from 'vue'
import Router from 'vue-router'
import Map from '@/components/Map'
import List from '@/components/List'
import ListUsers from '@/components/ListUsers'
import Login from '@/components/Login'
import Drivers from '@/components/Drivers'
import Graphs from '@/components/Graphs'
import Reports from '@/components/Reports'
import Pois from '@/components/Pois'
import Vehicles from '@/components/Vehicles'
import Settings from '@/components/Settings'
import kft from '@/components/kft'
import Fms from '@/components/Fms'
import FmsAnalog from '@/components/FmsAnalog'
import Actia from '@/components/Actia'
import AndroidApp from '@/components/AndroidApp'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/login',
      name: 'Login',
      component: Login,
      props: (route) => ({
        lg: route.query.lg,
        pw: route.query.pw,
      }),
    },
    {
      path: '/map',
      name: 'Map',
      component: Map,
      props: true,
    },
    {
      path: '/list',
      name: 'List',
      component: List,
    },
    {
      path: '/drivers',
      name: 'Drivers',
      component: Drivers,
    },
    {
      path: '/listusers',
      name: 'ListUsers',
      component: ListUsers,
    },
    {
      path: '/graphs',
      name: 'Graphs',
      component: Graphs,
    },
    {
      path: '/reports',
      name: 'Reports',
      component: Reports,
    },
    {
      path: '/pois',
      name: 'Pois',
      component: Pois,
    },
    {
      path: '/settings',
      name: 'Settings',
      component: Settings,
    },
    {
      path: '/vehicles',
      name: 'Vehicles',
      component: Vehicles,
    },
    {
      path: '/kft',
      name: 'KFT',
      component: kft,
    },
    {
      path: '/fms',
      name: 'FMS',
      component: Fms,
    },
    {
      path: '/actia',
      name: 'Actia',
      component: Actia,
    },
    {
      path: '/androidapp',
      name: 'AndroidApp',
      component: AndroidApp,
    },
  ],
})
